import { render, staticRenderFns } from "./ShareOfShelfKeywordModal.vue?vue&type=template&id=188ab3fc&scoped=true"
import script from "./ShareOfShelfKeywordModal.vue?vue&type=script&lang=js"
export * from "./ShareOfShelfKeywordModal.vue?vue&type=script&lang=js"
import style0 from "./ShareOfShelfKeywordModal.vue?vue&type=style&index=0&id=188ab3fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ab3fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188ab3fc')) {
      api.createRecord('188ab3fc', component.options)
    } else {
      api.reload('188ab3fc', component.options)
    }
    module.hot.accept("./ShareOfShelfKeywordModal.vue?vue&type=template&id=188ab3fc&scoped=true", function () {
      api.rerender('188ab3fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/modals/ShareOfShelfKeywordModal.vue"
export default component.exports